'use strict';

angular.module('cvsApp')
  .factory("commonService",['loggerService',function(loggerService){

    var log = loggerService('paymentCollection-accountDataService');
    var encrypt = new JSEncrypt();
    var _publicKey;
    var _privateKey;
    return{
      setPublicKey:function(key){
        _publicKey=key;
      },
      setPrivateKey:function(key){
        _privateKey=key;
      },
      getPublicKey:function(){
        return _publicKey;
      },
      getEncryptedRSAData:function(data){
        var publicKey=_publicKey?_publicKey:wcmContent.specialty_help.prd_public_key;
        if(cvsUtility.queryMap.env && cvsUtility.queryMap.env==="prod"){
          publicKey=_publicKey?_publicKey:wcmContent.specialty_help.prd_public_key;
        }else{
          publicKey=_publicKey?_publicKey:wcmContent.specialty_help.nonprd_public_key;
        }
        encrypt.setPublicKey(publicKey);
        if(!this.testEncryptData(encrypt.encrypt(data))){
            return false;
        }
        return encrypt.encrypt(data);
      },
      getDecryptedData:function(data){
        var privateKey=_privateKey?_privateKey:wcmContent.privateKey;
        encrypt.setPrivateKey(privateKey);
        return encrypt.decrypt(data);
      },
      testEncryptData: function(data){
          var re = new RegExp("^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$");
          if(!re.test(data)){
               return false;
          }
          return true;
      },
    }

  }]);
